document.addEventListener("DOMContentLoaded", () => {

  function updatePricing() {
    

    const pricingData =
document.getElementById(
"embroidery-pricing-data"
);

let BASE_PRICE = 25;

if (
  window.currentEmbroideryVariant &&
  window.currentEmbroideryVariant.price
) {

  BASE_PRICE =
    window.currentEmbroideryVariant.price / 100;

}
    let total = BASE_PRICE;
    const basePriceDisplay =
document.getElementById(
  "base-price"
);

if(basePriceDisplay){

  basePriceDisplay.innerText =
    "$" + BASE_PRICE.toFixed(2);

}

    let textSizeCost = 0;
    let imageCost = 0;
    let placementCost = 0;
    let appliqueCost = 0;
    let finishCost = 0;
    let monogramCost = 0;
    let puffCost = 0;
    let artworkCost = 0;
    let densityCost = 0;
    let stitchCost = 0;
    let outlineCost = 0;
    let shadowCost = 0;

    /* ======================
       TEXT SIZE
    ====================== */

    document
.querySelectorAll(
".embroidery-text-layer"
)
.forEach(layer => {

  const fontSize =
  parseInt(
  layer.dataset.fontSize || 32
  );

  if(fontSize >= 48 && fontSize < 64)
    textSizeCost += 10;

  if(fontSize >= 64)
    textSizeCost += 20;

});

    total += textSizeCost;

    /* ======================
       IMAGE SIZE
    ====================== */

    document
      .querySelectorAll(".embroidery-image-layer")
      .forEach(layer => {

        const width =
          parseInt(layer.style.width || 150);

        if (width >= 250 && width < 400)
          imageCost += 15;

        if (width >= 400)
          imageCost += 25;
      });

    total += imageCost;

    /* ======================
       PLACEMENT
    ====================== */

    const placementValue =
      document.getElementById("placementType")?.value;

    if (placementValue === "corner")
      placementCost = 8;

    if (placementValue === "largeBack")
      placementCost = 15;

    if (placementValue === "wrapAround")
      placementCost = 25;

    total += placementCost;

    /* ======================
   APPLIQUE
====================== */

const appliqueValue =
  document.getElementById(
    "appliqueType"
  )?.value;

console.log(
  "APPLIQUE VALUE:",
  appliqueValue
);

if (
  appliqueValue &&
  appliqueValue !== "0"
) {
  appliqueCost = 12;
} else {
  appliqueCost = 0;
}

total += appliqueCost;

console.log(
  "APPLIQUE COST:",
  appliqueCost
);

    /* ======================
       THREAD FINISH
    ====================== */

    const finishValue =
      document.getElementById("threadFinish")?.value;

    if (finishValue === "metallic")
      finishCost = 8;

    if (finishValue === "glow")
      finishCost = 12;

    if (finishValue === "neon")
      finishCost = 10;

    if (finishValue === "variegated")
      finishCost = 10;

    total += finishCost;

    /* ======================
       DENSITY
    ====================== */

    const densityValue =
      document.getElementById("stitchDensity")?.value;

    if (densityValue === "premium")
      densityCost = 8;

    if (densityValue === "luxury")
      densityCost = 15;

    total += densityCost;

    /* ======================
       STITCH TYPE
    ====================== */

    const stitchValue =
      document.getElementById("stitchType")?.value;

    if (stitchValue === "satin")
      stitchCost = 10;

    if (stitchValue === "raised")
      stitchCost = 15;

    if (stitchValue === "vintage")
      stitchCost = 12;

    total += stitchCost;

    /* ======================
       MONOGRAM
    ====================== */

    const monogramValue =
document.getElementById("monogramStyle")?.value;

switch(monogramValue){

case "traditional":
monogramCost = 15;
break;

case "interlocking":
monogramCost = 20;
break;

case "stacked":
monogramCost = 15;
break;

case "split":
monogramCost = 25;
break;

default:
monogramCost = 0;

}

    total += monogramCost;

    /* ======================
       3D PUFF
    ====================== */

    const puffValue =
document.getElementById(
  "puff3d"
)?.checked;

if(puffValue === "3d")
puffCost = 15;

if(puffValue === "heavy")
puffCost = 25;

    total += puffCost;


    /* ======================
   ARTWORK COMPLEXITY
====================== */

const colorCount =
parseInt(
window.detectedArtworkColors || 0
);

let artworkLabel = "Simple";

if(colorCount >= 4)
artworkLabel = "Moderate";

if(colorCount >= 7)
artworkLabel = "Complex";

if(colorCount >= 10)
artworkLabel = "Highly Complex";

artworkCost = 0;

document
.querySelectorAll(
  ".embroidery-image-layer"
)
.forEach(layer => {

  artworkCost +=
    parseFloat(
      layer.dataset.digitizingFee || 0
    );
  const colorCount =
parseInt(
  layer.dataset.colorCount || 0
);

let colorFee = 0;

if (colorCount >= 4 && colorCount <= 8)
  colorFee = 5;

if (colorCount >= 9 && colorCount <= 15)
  colorFee = 10;

if (colorCount >= 16 && colorCount <= 25)
  colorFee = 20;

if (colorCount >= 26 && colorCount <= 40)
  colorFee = 35;

if (colorCount >= 41)
  colorFee = 50;

artworkCost += colorFee;  

});

total += artworkCost;
    const outlineValue =
document.getElementById("outlineEmbroidery")?.value;

if(outlineValue === "classic")
outlineCost = 2;

if(outlineValue === "bold")
outlineCost = 4;

if(outlineValue === "double")
outlineCost = 6;

total += outlineCost;
const shadowValue =
document.getElementById("shadowEmbroidery")?.value;

if(shadowValue === "soft")
shadowCost = 3;

if(shadowValue === "drop")
shadowCost = 5;

if(shadowValue === "offset")
shadowCost = 5;

total += shadowCost;
let spoolCount = 1;

if(colorCount >= 4)
  spoolCount = 2;

if(colorCount >= 7)
  spoolCount = 3;

if(colorCount >= 10)
  spoolCount = 4;

const spoolDisplay =
document.getElementById("thread-spools");

if(spoolDisplay){
  spoolDisplay.innerText = spoolCount;
}
let stitchCount = 5000;

stitchCount += textSizeCost * 500;

stitchCount += imageCost * 800;

stitchCount += densityCost * 1000;

stitchCount += artworkCost * 1500;

const stitchDisplay =
document.getElementById("stitch-count");

if(stitchDisplay){
  stitchDisplay.innerText =
  stitchCount.toLocaleString();
}
let upgrades = [];

if(textSizeCost)
  upgrades.push("Large Text");

if(imageCost)
  upgrades.push("Artwork Upgrade");
if(artworkCost)
upgrades.push(
  "Digitizing"
);

if(placementCost)
  upgrades.push("Placement");

if(appliqueCost)
  upgrades.push("Applique");

if(finishCost)
  upgrades.push("Premium Thread");

if(monogramCost)
  upgrades.push("Monogram");

if(puffCost)
  upgrades.push("3D Puff");

if(outlineCost)
upgrades.push("Outline");

if(shadowCost)
upgrades.push("Shadow");

if(densityCost)
upgrades.push("Premium Density");

if(stitchCost)
upgrades.push("Special Stitch");
const upgradeSummary =
document.getElementById(
  "upgrade-summary"
);

if(upgradeSummary){

  upgradeSummary.innerHTML =
  upgrades.join("<br>");

}

    /* ======================
       DISPLAY
    ====================== */

    const threadColorDisplay =
    document.getElementById("thread-color-count");

    if(threadColorDisplay){
    threadColorDisplay.innerText =
    colorCount;
    }
    const artworkComplexityDisplay =
document.getElementById("artwork-complexity");

if(artworkComplexityDisplay){
  artworkComplexityDisplay.innerText =
  artworkLabel;
}
    const update = (id, value) => {
      const el = document.getElementById(id);
      if (el) el.innerText = "$" + value;
    };

    update("text-size-price", textSizeCost);
    update("image-price", imageCost);
    update("placement-price", placementCost);
    update("applique-price", appliqueCost);
    update("finish-price", finishCost);
    update("density-price", densityCost);
    update("stitch-price", stitchCost);
    update("monogram-price", monogramCost);
    update("puff-price", puffCost);
    update("digitizing-price", artworkCost);
    update("outline-price", outlineCost);
    update("shadow-price", shadowCost);

    const totalDisplay =
      document.getElementById("embroidery-total");

    if (totalDisplay) {

  totalDisplay.innerText =
    "$" + total.toFixed(2);

  window.currentEmbroideryPrice =
    total.toFixed(2);

  updateReviewPanel(
    total,
    artworkLabel,
    colorCount,
    stitchCount,
    upgrades
  );

}

  }

  updatePricing();

  document.addEventListener(
  "embroideryUpdated",
  updatePricing
);
document.querySelectorAll(
  "select,input"
).forEach(el => {

  el.addEventListener(
    "change",
    updatePricing
  );

});
function updateReviewPanel(
  total,
  artworkLabel,
  colorCount,
  stitchCount,
  upgrades
){

  const reviewDesign =
    document.getElementById(
      "review-design"
    );

  const reviewOptions =
    document.getElementById(
      "review-options"
    );

  const reviewPrice =
    document.getElementById(
      "review-price"
    );

  if(reviewDesign){

    reviewDesign.innerHTML = `
      Text Layers:
      ${
        document.querySelectorAll(
          ".embroidery-text-layer"
        ).length
      }<br>

      Image Layers:
      ${
        document.querySelectorAll(
          ".embroidery-image-layer"
        ).length
      }<br>

      Artwork Complexity:
      ${artworkLabel}<br>

      Thread Colors:
      ${colorCount}<br>

      Estimated Stitches:
      ${stitchCount.toLocaleString()}
    `;

  }

  if(reviewOptions){

    reviewOptions.innerHTML =
      upgrades.length
      ? upgrades.join("<br>")
      : "No upgrades selected";

  }

  if(reviewPrice){

    reviewPrice.innerHTML =
      "$" + total.toFixed(2);

  }

}

});